import { FrmEntityTypeEnum } from '@zaoblako/shared/common/enums/frm-entity-type.enum';
import { ReportItemColumnTypeEnum } from '@zaoblako/shared/common/enums/report-item-column-type.enum';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { CardFieldDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-field-descriptor.dto';

/** All inplace PATCH fields from card descriptor widgets (requisites + participants + …). */
export const collectCardPatchableFields = (
  descriptor: CardDescriptorInterface | null | undefined
): Map<string, CardFieldDescriptorInterface> => {
  const map = new Map<string, CardFieldDescriptorInterface>();
  const widgets = descriptor?.widgets;
  if (!widgets) {
    return map;
  }

  for (const widget of Object.values(widgets)) {
    for (const field of widget.fields ?? []) {
      map.set(field.key, field);
    }
  }

  return map;
};

/**
 * After PATCH, merge expanded relation arrays from the response (e.g. user groups with `usersCount`).
 * Driven by descriptor `frmEntityType` + `isArray`, same idea as registry v2 columns.
 */
export const shouldMergeCardPatchResponseFromRelation = (
  field: CardFieldDescriptorInterface | undefined
): boolean => {
  if (field?.type !== ReportItemColumnTypeEnum.FRM_ENTITY || !field.frmEntityType) {
    return false;
  }

  if (field.isArray === true) {
    return (
      field.frmEntityType === FrmEntityTypeEnum.BASIS_SECURITY_USER_GROUP ||
      field.frmEntityType === FrmEntityTypeEnum.BASIS_SECURITY_USER
    );
  }

  return field.frmEntityType === FrmEntityTypeEnum.BASIS_CATALOG_FILIAL;
};

/** Deal card: changing company or contragent may auto-pick contract. */
export const shouldRefreshDealContractOnCardPatch = (
  field: CardFieldDescriptorInterface | undefined
): boolean =>
  field?.frmEntityType === FrmEntityTypeEnum.BASIS_CLIENT_COMPANY ||
  field?.frmEntityType === FrmEntityTypeEnum.BASIS_CLIENT_CONTRAGENT;
